import React, { useEffect, useState, useMemo } from "react";
import { makeStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Paper from "@material-ui/core/Paper";
import Link from "@material-ui/core/Link";
import Typography from "@material-ui/core/Typography";
import UserDetails from "./component/UserDetails";
import axios from "axios";
import Loader from "../../../utilityComponents/Loader";
import Message from "../../../utilityComponents/Message";
function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      <Link color="inherit" href="https://mui.com/">
        Your Website
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  layout: {
    width: "auto",
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
      width: 600,
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
  },
}));

const Registraton = (props) => {
  const classes = useStyles();
  const [roles, setRoles] = useState([]);
  const [loader, setLoader] = useState(false);
  const [error, setError] = useState([]);
  const [success, setSuccess] = useState(null);
  const [formData, setFormData] = useState({});
  const onSubmit = async (validateInputFields, errorField) => {
    const isErrorOccured = validateInputFields(formData, errorField);
    if (isErrorOccured) return;
    setSuccess(null);
    setLoader(true);
    try {
      const response = await axios.post("/api/user/register", {
        contact: formData.phone,
        email_id: formData.emailAdd,
        emp_id: formData.empId,
        first_name: formData.firstName,
        full_name: formData.firstName + " " + formData.lastName,
        last_name: formData.lastName,
        role: formData.role,
        username: formData.emailAdd.split("@")[0],
      });
      setSuccess(response.data.message ? response.data.message : "User Added");
      setError([]);
      setFormData({});
    } catch (error) {
      setError([
        error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : "Coudn't fetch the Roles, Please Reload/Re-login.",
      ]);
    } finally {
      setLoader(false);
    }
  };

  const fetch=async ()=>{ 
    setLoader(true);
    try {
      const response = await axios.get("/api/user/accessible-roles");
      console.log(response);
      setRoles(response.data.roles);
    } catch (error) {
      console.log(error);
      setError((prev) => [
        ...prev,
        error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : "Coudn't fetch the Roles, Please Reload/Re-login.",
      ]);
    } finally {
      setLoader(false);
    }
  }

  useEffect(() => {
    
    fetch()
  }, []);

  return (
    <React.Fragment>
      <CssBaseline />
      {/* <AppBar position="absolute" color="default" className={classes.appBar}>
        <Toolbar>
          <Typography variant="h6" color="inherit" noWrap>
           KPIT
          </Typography>
        </Toolbar>
      </AppBar> */}
      <main className={classes.layout}>
        <Paper className={classes.paper}>
          <Typography component="h1" variant="h4" align="center">
            Registration
          </Typography>
          <React.Fragment>
            {success && <Message variant="success">{success}</Message>}
            {error.length > 0 && (
              <Message variant="warning">
                {error.map((error, index) => {
                  return <div key={index}>{error}</div>;
                })}
              </Message>
            )}
            {loader ? (
              <Loader />
            ) : (
              <React.Fragment>
                <UserDetails
                  formData={formData}
                  setFormData={setFormData}
                  roles={roles}
                  onSubmit={onSubmit}
                />
              </React.Fragment>
            )}
          </React.Fragment>
        </Paper>
      </main>
    </React.Fragment>
  );
};

export default Registraton;
